<script lang="ts">
    import Fa from 'svelte-fa'
    import { faArrowsLeftRight, faImage } from '@fortawesome/free-solid-svg-icons'

    export let data: Record<string, any>
</script>

<div class="block-preview">
    <Fa icon={faImage} />
    <Fa icon={faArrowsLeftRight} class="compare-icon" />
    <Fa icon={faImage} />
    <span>Até 2 fotos (antes/depois) — quem visualizar escolhe lado a lado ou sobreposto</span>
</div>

<style>
    .block-preview {
        max-width: 460px;
        height: 64px;
        border: 1px dashed #c7cdd4;
        border-radius: 8px;
        background: #f8f9fa;
        display: flex;
        align-items: center;
        gap: 10px;
        color: #868e96;
        font-size: 0.82rem;
        padding: 0 16px;
    }
    :global(.compare-icon) {
        opacity: 0.6;
        font-size: 0.75em;
    }
</style>
